export class PlanSubplanModel {
  public id: number;
  public subplanes: number[];

  constructor(id: number, subplanes: number[]) {
    this.id = id;
    this.subplanes = subplanes;
  }
}
